import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    disabled: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      subTotalNumber: 0,
      discountNumber: 0,
      taxNumber: 0,
      totalNumber: 0,
      taxes: [],
    }
  },
  computed: {
    ...mapGetters({
      queue_number: 'getPosSelectedQueueNumber',
      table_number: 'getPosSelectedTableNumber', // current table number selected
      getPosOrdersById: 'getPosOrdersById', // get orders from table number
      getPosTotalPriceById: 'getPosTotalPriceById', // get total price from table number
      trickCalculateTotalPrice: 'trickCalculateTotalPrice',
      currency: 'getCurrency',
      section: 'getPosSection',
      currency: 'getCurrency',
      display: 'getPosDisplay',
      pos: 'getPos',
      isShowingConfirmClearPosOrdersModal: 'isShowingConfirmClearPosOrdersModal',
    }),
    orders () {
      return this.getPosOrdersById({
        queue_number: this.queue_number,
        table_number: this.table_number,
      })
    },
    btnPaymentDisabled () {
      var class_ = 'disabled'
      if (this.orders.length > 0 && !this.$store.state.pos.pos.lastSecIsBarcode) {
        class_ = null
      }
      return class_
    },
    isValid () {
      return this.orders.length > 0
    },
  },
  methods: {
    ...mapActions([
      'setPosSection',
      'doCalculateTotalPrice',
      'setLastSecIsBarcode',
    ]),
    getTotalPrice (order) {

    },
    calc () {
      // clear
      this.clear()
      // get total price
      let result = this.getPosTotalPriceById({
        queue_number: this.queue_number,
        table_number: this.table_number,
      }, this.mixin)
      // get taxes
      this.taxes = this.getTaxesByOrders(this.orders)
      this.subTotalNumber = result.sub
      this.discountNumber = result.discount
      this.taxNumber = result.tax
      this.totalNumber = result.total
    },
    clear () {
      this.subTotalNumber = 0
      this.discountNumber = 0
      this.taxNumber = 0
      this.totalNumber = 0
      this.taxes = []
    },
    onClickPayment () {
      if (!this.isValid) {
        return
      }
      this.setPosSection('payment')
    },
    handleKeyup (e) {
      let that = this
      let isPosSection = this.$store.state.app.section == 'pos'
      let isPageChooseProduct = this.$store.state.pos.pos.section == 'choose-product'
      let lastSecIsBarcode = that.$store.state.pos.pos.lastSecIsBarcode
      if (isPosSection && isPageChooseProduct) {
        if (e.key == 'Enter' && !lastSecIsBarcode && !this.isShowingConfirmClearPosOrdersModal) {
          setTimeout(() => {
            let isValid = that.getPosOrdersById({
              queue_number: that.queue_number,
              table_number: that.table_number,
            }).length > 0
            if (isValid) {
              if (!this.display.search) {
                that.onClickPayment()
              }
            }
          }, 1)
        }
      }
    },
  },
  watch: {
    trickCalculateTotalPrice () {
      this.calc()
    },
    'pos': {
      handler: function (after, before) {
        this.calc()
      },
      deep: true,
    },
  },
  mounted: function () {
    this.doCalculateTotalPrice()

    setTimeout(() => this.doCalculateTotalPrice(), 1000)

    // event keyboard
    window.addEventListener('keyup', this.handleKeyup, false)
  },
  destroyed: function () {
    // remove event keyboard
    window.removeEventListener('keyup', this.handleKeyup, false)
  },
}



// WEBPACK FOOTER //
// ./src/mixins/pos/totalPrice.js